import { queryAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const pastebin = defineConnector({
  identifier: "pastebin",
  name: "Pastebin",
  tagLine: "Text sharing API",
  logo,
  protocol: "http",
  tags: ["communication"],
  defaultUrlPattern: () => "https://pastebin\\.com/.*",
  auth: (app) =>
    queryAuth([
      { name: "api_dev_key", value: app.secret.apiDevKey },
      { name: "api_user_key", value: app.secret.apiUserKey },
    ]),
  steps: [
    {
      title: "Collect the required credentials for Pastebin",
      items: [
        {
          kind: "markdown",
          content:
            "Follow the official docs at [https://pastebin.com/doc_api](https://pastebin.com/doc_api) to create the credential values this API expects on each request.",
        },
      ],
    },
    {
      title: "Enter your connection details",
      items: [
        {
          kind: "input",
          label: "Developer API key",
          required: true,
          target: {
            kind: "secrets",
            field: "apiDevKey",
          },
        },
        {
          kind: "input",
          label: "User key",
          required: true,
          target: {
            kind: "secrets",
            field: "apiUserKey",
          },
        },
        {
          kind: "test-url",
          label: "Test URL",
          placeholder: "https://pastebin.com/",
          helperText:
            "Optional. Set this if you want testing to hit a specific endpoint instead of the default draft URL.",
          urlTarget: {
            kind: "configuration",
            field: "testUrl",
          },
          methodTarget: {
            kind: "configuration",
            field: "testMethod",
          },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ testUrl, testMethod }) => ({
      url: testUrl ?? (() => "https://pastebin.com/api")(),
      method: testMethod === "POST" ? "POST" : "GET",
    }),
  },
});
